import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { isEmpty } from "BaseFunctions";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openMembershipModal,
  openSponsorModal,
  editSponsorCategory,
} from "ActionsSponsors";
import CategoryListItem from "./categoryitem.js";
import CategoryForm from "./categoryform.js";
import LocaleStrings from "Languages";
import _ from "lodash";

class ManageMembership extends Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    var inputClasses = "col-sm-7 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <div className={inputClasses} style={{ paddingRight: 0 }}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
          />
          <div
            className="text-help label-text-help"
            style={{ textAlign: "left" }}
          >
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  open = () => {
    this.props.openMembershipModal(true);
  };

  close = () => {
    this.props.openMembershipModal(false);
    this.props.editSponsorCategory({ toAdd: false, toEdit: false });
  };

  onFormSubmit = (values) => {
    var data = { ...values };
    this.setState({ loading: true });
  };

  onAddCategoryClick = () => {
    this.props.editSponsorCategory({ toAdd: true, toEdit: false });
  };

  additionCallback = () => {
    this.props.finishOperationsCallback();
  };

  paginationCallback = (pageNumber) => {
    this.props.paginationCallback(pageNumber);
  };

  renderList() {
    let { pageNumber, sponsors } = this.props;
    let pageDataLength =
      sponsors.data && sponsors.data.length > 0 ? sponsors.data.length : 1;
    var items = [];

    if (this.props.sponsorCategories && this.props.sponsorCategories.length > 0)
      items = _.map(this.props.sponsorCategories, (category) => (
        <CategoryListItem
          key={category.id}
          category={category}
          pagination={this.paginationCallback}
          operationsCallback={this.additionCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
        />
      ));
    return items;
  }

  render() {
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal === true ? true : false}
        onHide={this.close}
        animation={true}
        keyboard={false}
        backdrop="static"
        dialogClassName="size700PxModal"
      >
        <Modal.Header>
          <div className="import-modal-title">
            {LocaleStrings.sponsor_managecategories}
          </div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={() => this.close()}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="import-header">
            <div className="import-modal-title">Manage Categories</div>
            <button type="button" className="close btn-sm btn-close " onClick={() => this.close()} style={{marginTop:-25}}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div> */}
          {this.props.addOrEdit ? (
            <CategoryForm operationsCallback={this.additionCallback} />
          ) : (
            <div>
              <div style={{ padding: 10 }}>
                <div className="row">
                  <div className="col-md-8">
                    {LocaleStrings.sponsor_membership}
                  </div>
                  <div className="col-md-4">
                    <Button
                      className="btn btn-custom-blue pull-right"
                      onClick={this.onAddCategoryClick}
                    >
                      Add Category
                    </Button>
                  </div>
                </div>
              </div>
              <div className="categoryTableContainer">
                <table className="table sponsor-table">
                  <thead>
                    <tr>
                      <th>{LocaleStrings.sponsor_th_preview}</th>
                      <th>{LocaleStrings.sponsor_th_action}</th>
                    </tr>
                  </thead>
                  <tbody>{this.renderList()}</tbody>
                </table>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-custom-white"
            type="button"
            onClick={this.close}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    sponsors: state.sponsors,
    showModal: state.membershipModal,
    user: state.user,
    sponsorCategories: state.sponsorCategories.data,
    editCategory: state.editSponsorCategory,
    addOrEdit:
      state.editSponsorCategory.toEdit || state.editSponsorCategory.toAdd,
  };
}

export default connect(mapStateToProps, {
  openMembershipModal,
  showError,
  showSuccess,
  editSponsorCategory,
})(ManageMembership);
